import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TypingEffect from "../HomePage/VideoComponent/TypingEffect";
import "./HomeHeader.css";

const HomeHeader = ({ title, description }) => {
  return (
    <>
      <Container
        className="py-4 text-center rounded responsive-text"
        style={{ maxWidth: "1000px" }}
      >
        <Row>
          <Col>
            <h1 className="text-white">
              <TypingEffect text={title} />
            </h1>

            <p className="mt-3 n-color-light">{description}</p>
            <p>
              <TypingEffect text="אני מזמין אתכם לשתף את וולוגים שלי. מקווה שתהנו!" />
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HomeHeader;
